import { render, staticRenderFns } from "./ChangeAvatarModal.vue?vue&type=template&id=28bf54cf&"
import script from "./ChangeAvatarModal.vue?vue&type=script&lang=js&"
export * from "./ChangeAvatarModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports